import { useState, useEffect } from 'react';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import FormHelpText from './form-helpText';

const FormInputNumber = ({ item, unique, submitted }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const validate = (val) => {
    if (item.required && val === '') {
      setError(true);
    } else {
      setError(false);
    }
  };

  useEffect(() => {
    if (submitted) {
      validate(value);
    }
  });

  return (
    <>
      <FormGroup className="tw-py-4">
        <InputLabel className="tw-font-normal tw-text-[#42474a] tw-pb-2 tra-text-web-body-m">{`${
          item.title
        }${item.required ? ' *' : ''}`}</InputLabel>
        <TextField
          type="number"
          value={value}
          title={value}
          variant="outlined"
          fullWidth
          onBlur={(e) => validate(e.target.value)}
          onChange={(e) => setValue(e.target.value)}
          id={`form-${unique}`}
          name={unique}
          required={item.required}
          aria-describedby={`${unique}-help`}
          aria-labelledby={`${unique}-help`}
          error={error}
          helperText={error ? item.validationMessage : ''}
          FormHelperTextProps={{
            className: 'tw-mt-1',
          }}
          InputProps={{
            style: {
              backgroundColor: '#ffffff',
              boxShadow: error ? `0px 0px 0px 3px rgba(209, 26, 10, 0.4)` : '',
              '&.Mui-focused': {
                boxShadow: error
                  ? `0px 0px 0px 3px rgba(209, 26, 10, 0.4)`
                  : '0px 0px 0px 3px rgba(217, 94, 22, 0.4)',
              },
              '&.MuiOutlinedInput-notchedOutline': {
                borderColor: '#ecedee',
              },
            },
            endAdornment: (
              <InputAdornment position="end">
                {error ? (
                  <CancelIcon color="error" />
                ) : value === '' ? (
                  ''
                ) : (
                  <CheckCircleIcon color="primary" />
                )}
              </InputAdornment>
            ),
          }}
        />
        <FormHelpText
          display={!!item.helpText}
          unique={unique}
          content={item.helpText !== undefined ? item.helpText : ''}
        />
      </FormGroup>
    </>
  );
};

export default FormInputNumber;
